import type { Route } from 'vue-router';
import { warRoomStates } from './constants';
import { buildQuery, makeUrl } from '~/components/utils/browser/url';
import type { Votable } from '~/types/common';
import type { CurrentUser } from '~/types/';

export const isExtraRoleAdmin = () => {
  if (process.server) {
    return false;
  }

  return localStorage.getItem('extra-role') === 'admin';
};

export const makeCanonicalUrlForPagination = ({ path, query }: Partial<Route>) => {
  const { page } = query!;
  // We must remove page=1 from canonical url
  const pageNumber = Number(page) <= 1 ? undefined : page;
  return makeUrl(`${path}${buildQuery({ page: pageNumber }, true)}`);
};

export const calculateUpvote = (votable: Votable, value: number): { currentRating: number; nextRating: number } => {
  const currentRating = votable.current_vote ? votable.rating - votable.current_vote : votable.rating;
  const nextRating = currentRating + value;

  return { currentRating, nextRating };
};

export const calculateDownvote = (votable: Votable): { currentRating: number; nextRating: number } => {
  const nextRating = votable.rating - votable.current_vote;

  return { currentRating: votable.rating, nextRating };
};

export const isWarRoomUser = (user: Partial<CurrentUser>) => {
  return user?.warRoomState === warRoomStates.MEMBER;
};

export const dropRedundantWhitespace = (input = '') =>
  input
    // Replace all line breaks and spaces before and after
    .replace(/((&nbsp;\s?)+)?(<p>)?<br>?(<\/p>)?((&nbsp;\s?)+)?/g, '\n')
    .replace(/(&nbsp;\s?)+/g, ' ')
    .replace(/<div>(\n)?<br>(\n)?<\/div>/gim, '\n')
    .replace(/<div>(\n)?<\/div>/gi, '\n')
    // remove all divs as our editor doesn't allow them
    .replace(/<div>/gi, '')
    .replace(/<\/div>/gi, '\n')
    // fix lists BT-145
    .replace(/>\n</g, '><')
    .trim()
    // Collapse redundant line breaks
    .replace(/\n+/g, match => (match === '\n' ? '<br>' : '<br><br>'));

// Previously we had a bug in BE that removed space after the link/mention
// That's a quickfix for old comments/posts
//
// better to change all comments/posts in db
export const fixLinkWhitespace = (input = '') => {
  const regex = /(<\/a>)([^.,\)";: \n!?&])/gm;
  return input.replace(regex, (_, tag, text) => {
    return `${tag} ${text}`;
  });
};
